<template>
    <el-dialog title="取消入库" :visible.sync="inCancelDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
            <el-form-item label="取消原因" prop="reason">
                <el-input size="small" v-model="formData.reason" type="textarea" :rows="6" placeholder="请输入取消原因"></el-input>
            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { pendingInCancel } from "@/api/index.js"
export default {
    name: "in_cancel_product",
    props: {
        inCancelDialog: {
            type: Boolean,
            default: false
        },
        inColumnId: {
            type: Number,
            default: 0
        },
        inColumnInfo: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            BtnDisabled:false,
            formData: {
                reason: "",
            },
            formRules: {
                reason: [
                    {required: true, message: "请输入取消原因"}
                ]
            },
            userList: []
        }
    },
    created() {

    },
    methods: {
        handleDialogClose() {
            this.$emit("update:inCancelDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    let postData = {
                        stock_pending_id:this.inColumnInfo.stock_pending_id,
                        stock_type:this.inColumnInfo.stock_type,
                        biz_type:this.inColumnInfo.biz_type,
                        biz_type_id:this.inColumnInfo.biz_type_id,
                        reason:this.formData.reason
                    }
                    this.BtnDisabled = true
                    pendingInCancel(postData).then(res=> {
                        if(res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: res.message,
                                duration: 1500,
                                onClose: () => {
                                    this.handleDialogClose()
                                    this.$emit('success')
                                    this.BtnDisabled = false
                                }
                            })
                        }else{
                            this.BtnDisabled = false
                        }
                    })
                }
            })
        },

    }
}
</script>
